import React, { useEffect } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimations';

const ScrollAnimationWrapper = ({ 
  children, 
  animation = 'fadeInUp',
  delay = 0,
  duration = 800,
  className = '',
  threshold = 0.1,
  triggerOnce = true,
  stagger = false,
  staggerDelay = 100
}) => {
  const { elementRef } = useScrollAnimation(animation, threshold, delay);

  // Stagger animacije ako je potrebno
  useEffect(() => {
    if (!elementRef.current || !stagger) return;

    const element = elementRef.current;
    
    // Handle stagger animation for children
    if (element.children.length > 0) {
      Array.from(element.children).forEach((child, index) => {
        child.style.transitionDelay = `${delay + (index * staggerDelay)}ms`;
      });
    }

  }, [delay, stagger, staggerDelay, elementRef]);

  return (
    <div 
      ref={elementRef}
      className={`scroll-animation-wrapper ${className}`}
    >
      {children}
    </div>
  );
};

// Predefined animation components za lakše korišćenje
export const FadeInUp = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="fadeInUp" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export const FadeInLeft = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="fadeInLeft" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export const FadeInRight = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="fadeInRight" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export const ScaleIn = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="scaleIn" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export const SlideInUp = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="slideInUp" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export const FlipInX = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="flipInX" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export const BounceIn = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="bounceIn" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export const RotateIn = ({ children, ...props }) => (
  <ScrollAnimationWrapper animation="rotateIn" {...props}>
    {children}
  </ScrollAnimationWrapper>
);

export default ScrollAnimationWrapper;
